module.exports = __webpack_public_path__ + "static/media/close.5d8fa210.svg";